<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/crs/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import Qs from 'qs'
  import axios from 'axios'
  let typeList={"1":"开通账户","2":"真实账户_后台开户","3":"真实账户_前端开户","4":"真实账户_资料上传","5":"真实账户_资料上传_审核成功","6":"真实账户_资料上传_审核失败","7":"真实账户_激活账户","8":"真实账户_存款成功","9":"真实账户_支付失败","10":"真实账户_重新支付成功","11":"真实账户_重新支付失败","12":"真实账户_交易","13":"真实账户_强制平仓","14":"真实账户_保证金不足","15":"真实账户_提交取款","16":"真实账户_取款审批拒绝","17":"真实账户_取款审批成功","18":"模拟账户_后台开户","19":"模拟账户_前端开户","20":"模拟账户_资料上传","21":"模拟账户_资料上传_审核成功","22":"模拟账户_资料上传_审核失败","23":"模拟账户_激活账户","24":"模拟账户_存款","25":"模拟账户_重新支付失败","26":"模拟账户_重新支付成功","27":"模拟账户_支付失败","28":"模拟账户_交易","29":"模拟账户_紧急平仓","30":"模拟账户_保证金不足","31":"模拟账户_取款","32":"模拟账户_提交取款"};//消息类型列表
  let businessIds={};//业务id
  let language={};//语言
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        } else if(clickName == "status"){
            this.$confirm(row.status == 1 ? '确定禁用?':"确定启用?", '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.$axios.get(URL.templateMsg.status+"/"+row.id+"?value="+(row.status ==1 ? 2:1)).then(res=> {
                    if (res.code == 0) {
                        this.$message.success("操作成功");
                        this.$refs.childTable.defaultGetData(this.queryData);
                    }
                });
            })
        }else if(clickName == "record"){
            this.$router.push({path:"/crstemplateMsg/record", query: { tempMsgId: row.id ,label:'CRS'} })
        }

      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage((model.id!=undefined && model.id!=null && model.id!='') ? URL.templateMsg.edit:URL.templateMsg.save,model,res => {
          if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("操作成功");
          this.$refs.childTable.defaultGetData(this.queryData);
        }else{

        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
                      ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
                          { title: '模板名称', field: 'name'},
                          { title: '消息类型', field: 'type',type:2,optionList:typeList},
                          { title: '状态', field: 'status',type:2,optionList:{"1":"启用","2":"禁用"}},
                          { title: '语言', field: 'templateLanguage',type:2,optionList:{"zh_CN":"zh_CN","en_US":"en_US","vi_VN":"vi_VN"}},
                          {click:"查询",auth:"sys:templateMsg:find"},
                          {click:"新增",auth:"sys:templateMsg:save"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.templateMsg.query, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                          { title: '模板名称', field: 'name'},
                          { title: '模板标题', field: 'title'},
                          { title: '业务id', field: 'businessId'},
                          { title: '语言', field: 'templateLanguage'},
                          { title: '消息类型', field: 'type'},
                          { title: '状态', field: 'status'},
                          { title: '消息内容', field: 'content'},
                          { title: '创建时间', field: 'createDate'},
                          { title: '修改时间', field: 'updateDate'},
              {title:"操作",btnClick:[
                      {name:"修改",click:"update",type:"primary",icon: "el-icon-edit",auth:"sys:templateMsg:edit"},
                      {name:(data,full)=>{
                              return full.status ==1 ? "禁用":"启用" ;
                          },click:"status",type:"primary",icon:(data,full)=>{
                              return full.status== 1 ? "el-icon-star-on":"el-icon-star-off";
                          },auth:"sys:templateMsg:status"},
                      {name:"记录",click:"record",type:"primary",icon:"el-icon-video-camera-solid",auth:"sys:templateMsg:record"}
                  ]}
          ]
        }
      }
    },
      created(){
          this.$axios.get(URL.templateMsg.getData).then(res=> {
              if (res.code == 0) {
                  language = res.result.language;
                  businessIds = res.result.businessIds;
                  this.updateData.cols=[ { title: 'id', field: 'id',hidden:true},
                      { title: '模板名称', field: 'name',required:true},
                      { title: '模板标题', field: 'title',required:true},
                      { title: '业务id', field: 'businessId',type:3,optionList:businessIds,required:true,data:"108"},
                      { title: '语言', field: 'templateLanguage',type:3,optionList:language,required:true,data:"zh_CN"},
                      { title: '消息类型', field: 'type',type:2,optionList:typeList,required:true},
                      { title: '状态', field: 'status',type:3,optionList:{"1":"启用","2":"禁用"},data:"1",required:true},
                      { title: '消息内容', field: 'content',type:6}
                  ];
              }
          });
      }
  }
</script>
